import { render, staticRenderFns } from "./originalInterview.vue?vue&type=template&id=64691b3e"
import script from "./originalInterview.vue?vue&type=script&lang=js"
export * from "./originalInterview.vue?vue&type=script&lang=js"
import style0 from "./originalInterview.vue?vue&type=style&index=0&id=64691b3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports